import React from "react";
import PT from "prop-types";
import "./styles.m.css";

const Button = ({ children, className }) => {
  return (
    <button styleName="button" className={className}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PT.node.isRequired,
  className: PT.string
};

export { Button };
